import { useRouter } from 'next/router';
import { useCallback } from 'react';

import { Header } from '~/components/Header';
import type { OnSubmit } from '~/contexts/FormContext/types';
import { SearchFormContextProvider, type SearchFormType } from '~/contexts/SearchFormContext/SearchFormContext';
import { useGenerateSearchUrl } from '~/hooks/useGenerateSearchUrl';
import { navigateOrReload } from '~/utils/navigation';

type SEOHeaderProps = {
  title: string;
  hideSearch?: boolean;
};

export const SEOHeader = ({ title, hideSearch }: SEOHeaderProps) => {
  const { push } = useRouter();
  const generateSearchUrl = useGenerateSearchUrl();

  const handleFormSubmit: OnSubmit<SearchFormType> = useCallback(
    async params => {
      const url = generateSearchUrl(params);
      await navigateOrReload(push, url, { scroll: false });
    },
    [push, generateSearchUrl],
  );

  return (
    <SearchFormContextProvider onSubmit={handleFormSubmit}>
      <Header title={title} hideImage hideSearch={hideSearch} />
    </SearchFormContextProvider>
  );
};
